import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Box,
    TextField,
    Button,
    MenuItem,
    Grid,
    IconButton,
    Typography,
    Autocomplete,
} from "@mui/material";
import axios from "axios";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Key from "../../clientVariables.json";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { CloseOutlined } from "@mui/icons-material";
import logoImg from "../../Components/images/logo.png";
import { getCitiesAction, getCountriesAction, getStatesAction } from "../redux/action";
import { appSelector } from "../redux/selector";
import CustomLoadingButton from "./Customloadingbutton";
import {
    job_types_data,
    us_states_data,
    visa_types_data,
} from "./Commondata";

const PersonalDetailsModal = ({ modalState, onClose, onSubmit }) => {
    const [cityList, setCityList] = useState([]);
    const [formValues, setFormValues] = useState({
        gender: "",
        ssn_last_4: "",
        dob: "",
        state: "",
        city: "",
    });
    const primaryResumeDetails = useSelector(
        (state) => state.primaryResumeReducer?.resume
    );

    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);

    // useEffect(() => {
    //   const genderValid = getValidValueReturnNull(primaryResumeDetails?.gender);
    //   setFormValues((prevFormValues) => ({
    //     ...prevFormValues,
    //     gender: genderValid,
    //     ssn_last_4: "",
    //     dob: "",
    //     state: "",
    //     city: "",
    //   }));
    // }, [primaryResumeDetails]);

    useEffect(() => {
        // console.log(initialData);
        const initialData = modalState?.initialData;
        if (initialData) {
            const selectedState = us_states_data.find(
                (state) => state.id == initialData.state
            );
            // console.log(selectedState);
            setFormValues((prevFormValues) => ({
                ...prevFormValues,
                dob: initialData?.date_of_birth
                    ? new Date(initialData?.date_of_birth).toString() !== "Invalid Date"
                        ? new Date(initialData?.date_of_birth)
                        : null
                    : null,
                gender: initialData?.gender,
                ssn_last_4: initialData?.SSN,
                state: selectedState?.id,
            }));
        }
    }, [modalState?.initialData]);

    useEffect(() => {
        const initialData = modalState?.initialData;
        if (initialData?.city && cityList.length > 0) {
            const selectedCity = cityList.find((city) => city.id == initialData.city);
            console.log(selectedCity);
            if (selectedCity) {
                setFormValues((prev) => ({
                    ...prev,
                    city: selectedCity.id,
                }));
            }
        }
    }, [cityList, modalState?.initialData]);

    useEffect(() => {
        const initialData = modalState?.initialData;
        if (formValues.state?.id) {
            getCities(formValues.state?.id);
        } else if (formValues.state) {
            getCities(formValues.state);
        } else {
            setCityList([]);
        }
    }, [formValues.state, modalState?.initialData]);

    const handleInputChange = (field, value) => {
        setFormValues((prev) => ({
            ...prev,
            [field]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [field]: null,
        }));
    };

    const handleChange = (event) => {
        const value = event.target.value;
        if (/^\d{0,4}$/.test(value)) {
            setFormValues((prev) => ({
                ...prev,
                ssn_last_4: value,
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formValues.ssn_last_4)
            newErrors.ssn_last_4 = "Last 4 of SSN is required.";
        if (!formValues.gender) newErrors.gender = "Gender is required.";
        if (!formValues.state) newErrors.state = "State is required.";
        if (!formValues.city) newErrors.city = "City is required.";
        if (!formValues.dob) newErrors.dob = "Date Of Birth is required.";
        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            onSubmit(formValues);
            // onClose();
        }
    };

    const getCities = (id) => {
        fetch(`${Key.domain_jnp}/commonAPIs/get_cities_by_stateid`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                state_id: id,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setCityList(data.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const fetchCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    try {
                        // Use reverse geocoding API to get location details
                        const response = await axios.get(
                            `https://nominatim.openstreetmap.org/reverse`,
                            {
                                params: {
                                    lat: latitude,
                                    lon: longitude,
                                    format: "json",
                                },
                            }
                        );
                        // console.log(response);

                        const locationData = response.data.address;
                        setFormValues({
                            ...formValues,
                            state: locationData.state || "",
                            city:
                                locationData.city ||
                                locationData.town ||
                                locationData.village ||
                                "",
                            zipcode: locationData.postcode || "",
                        });
                    } catch (err) {
                        setError("Failed to fetch location details.");
                        console.error("Error fetching location details:", err);
                    }
                },
                (err) => {
                    setError("Failed to get your location.");
                    console.error("Geolocation error:", err);
                }
            );
        } else {
            setError("Geolocation is not supported by your browser.");
        }
    };

    return (
        <Dialog
            open={modalState?.open === "personal_details" && modalState?.isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: "10px 22px 0px 22px",
                }}
            >
                <Box sx={{ display: "flex" }}>
                    <Box sx={{}}>
                        <img src={logoImg} width={120} />
                    </Box>
                    {/* <Typography id="transition-modal-title" variant="h6" component="h2" sx={{fontSize: '22px', color: '#5F6368', mt: '6px', fontWeight: 500}}>
          Account
          </Typography> */}
                </Box>
                <Box>
                    <IconButton aria-label="close-modal" onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </Box>
            </Box>
            <DialogTitle>Details</DialogTitle>
            <DialogContent>
                <Box sx={{}}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                select
                                label="Gender"
                                value={formValues.gender}
                                onChange={(e) => handleInputChange("gender", e.target.value)}
                                fullWidth
                                variant="standard"
                                required
                                size="small"
                                error={!!errors.gender}
                                helperText={errors.gender}
                            >
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                // margin="dense"
                                // id="ssn-last4"
                                label="Last 4 Digits of SSN"
                                type="text"
                                value={formValues.ssn_last_4}
                                onChange={handleChange}
                                fullWidth
                                variant="standard"
                                required
                                inputProps={{ maxLength: 4 }}
                                error={!!errors.ssn_last_4}
                                helperText={errors.ssn_last_4}
                            />
                        </Grid>

                        {/* <Grid item xs={12}>
        <TextField
    label="Address"
    value={formValues.address}
    onChange={(e) =>
        handleInputChange("address", e.target.value)
      }
    fullWidth
    variant="standard"
    required
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={fetchCurrentLocation} edge="end">
            <MyLocationOutlined />
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
        </Grid> */}
                        <Grid item xs={4}>
                            <TextField
                                select
                                label="Country"
                                value="USA"
                                fullWidth
                                variant="standard"
                                size="small"
                                disabled
                            >
                                <MenuItem key="USA" value="USA">
                                    United States Of America
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <Autocomplete
                                options={us_states_data}
                                getOptionLabel={(option) => option.name}
                                value={
                                    us_states_data.find(
                                        (state) => state.id === formValues.state
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    handleInputChange("state", newValue ? newValue.id : "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="State"
                                        variant="standard"
                                        fullWidth
                                        required
                                        size="small"
                                        error={!!errors.state}
                                        helperText={errors.state}
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <Autocomplete
                                options={cityList}
                                getOptionLabel={(option) => option.cityName || ""}
                                // value={formValues.city || null}
                                value={
                                    cityList?.find((city) => city.id === formValues.city) || null
                                }
                                onChange={(event, newValue) =>
                                    handleInputChange("city", newValue ? newValue.id : "")
                                }
                                disabled={!formValues.state}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="City"
                                        variant="standard"
                                        fullWidth
                                        required
                                        size="small"
                                        error={!!errors.city}
                                        helperText={errors.city}
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MobileDatePicker
                                    label="Date Of Birth"
                                    value={formValues.dob}
                                    onChange={(newValue) => handleInputChange("dob", newValue)}
                                    // views={["month", "year"]}
                                    maxDate={new Date()}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            fullWidth
                                            required
                                            error={!!errors.startDate}
                                            helperText={errors.startDate}
                                            size="small"
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                {/* <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button> */}
                <CustomLoadingButton
                    loading={modalState?.loading}
                    success={modalState?.success}
                    onClick={handleSubmit}
                >
                    Save
                </CustomLoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default PersonalDetailsModal;